import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const Steps = (props: RealEstateDataPageComponentData) => {
  const {
    items,
    darkMode,
    is_wide,
    titleElement,
    titleColor,
    titleHexa,
    backgroundColor,
    backgroundHexa,
    customFontSize,
  } = props

  return (
    <section
      style={{ backgroundColor: backgroundColor ? backgroundHexa : '' }}
      className={
        'development-steps a p-y-config ' +
        (is_wide ? 'is-wide-component ' : ' ') +
        (darkMode ? ' is-gray-background ' : '') +
        (' ' + backgroundColor)
      }
    >
      <Container fluid>
        <Col lg={{ offset: is_wide ? 0 : 2, span: is_wide ? 12 : 10 }}>
          <Row className="no-gutters d-flex justify-content-between align-items-stretch">
            <Col
              xs={12}
              lg={4}
              className="d-flex pb-4 justify-content-between"
            >
              <div className="content">
                <Row className="row">
                  <Col
                    xs={4}
                    lg={12}
                  >
                    <ElementHTML
                      elementType={titleElement || 'h2'}
                      style={{
                        color: titleHexa,
                        fontSize: customFontSize ? customFontSize + 'rem' : '',
                      }}
                      className={titleColor + ' value'}
                      children={items![0].value || ''}
                    />
                  </Col>
                  <Col
                    xs={8}
                    lg={12}
                  >
                    <h5 className="title">{items![0].title}</h5>
                    <p className="paragraph">{items![0].paragraph}</p>
                  </Col>
                </Row>
              </div>
              <div className="border-separator"></div>
            </Col>
            <Col
              xs={12}
              lg={4}
              className="pl-lg-5 d-flex pb-4 justify-content-between"
            >
              <div className="content">
                <Row>
                  <Col
                    xs={4}
                    lg={12}
                  >
                    <ElementHTML
                      elementType={titleElement || 'h2'}
                      style={{
                        color: titleHexa,
                        fontSize: customFontSize ? customFontSize + 'rem' : '',
                      }}
                      className={titleColor + ' value'}
                      children={items![1].value || ''}
                    />
                  </Col>
                  <Col
                    xs={8}
                    lg={12}
                  >
                    <h5 className="title">{items![1].title}</h5>
                    <p className="paragraph">{items![1].paragraph}</p>
                  </Col>
                </Row>
              </div>
              <div className="border-separator"></div>
            </Col>
            <Col
              xs={12}
              lg={4}
              className="d-flex pl-lg-5 pb-4"
            >
              <div className="content border-none">
                <div className="row">
                  <div className="col-4 col-lg-12">
                    <ElementHTML
                      elementType={titleElement || 'h2'}
                      style={{
                        color: titleHexa,
                        fontSize: customFontSize ? customFontSize + 'rem' : '',
                      }}
                      className={titleColor + ' value'}
                      children={items![2].value || ''}
                    />
                  </div>
                  <div className="col-8 col-lg-12">
                    <h5 className="title">{items![2].title}</h5>
                    <p className="paragraph">{items![2].paragraph}</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Container>
    </section>
  )
}

export default Steps
